<script setup lang="ts">
import { toOrdinal } from '@/lib/number.js';
import { isDefined } from '@/lib/types.js';
import { cn } from '@pokerly/ui';
import { IconGhost3 } from '@tabler/icons-vue';
import { computed } from 'vue';

interface Props {
    variant?: 'default' | 'icon';
    disabled?: boolean;
    expectedVotes?: number;
    totalVotes?: number;
    round?: number;
}

const props = withDefaults(defineProps<Props>(), {
    variant: 'default',
    disabled: false,
});

const canRenderVotes = computed(() => {
    return isDefined(props.totalVotes) && isDefined(props.expectedVotes);
});

const canRenderRound = computed(() => {
    return isDefined(props.round);
});
</script>

<template>
    <div :class="cn('p-2', 'flex', 'flex-col', 'justify-center', 'items-center', 'gap-4')">
        <IconGhost3 v-if="variant === 'icon'" class="size-10 text-foreground-subtle-alt" />
        <slot></slot>
        <div
            :class="
                cn(
                    'flex',
                    'gap-2',
                    'text-foreground-on-primary',
                    'paragraph-sm',
                    'font-bold',
                    disabled ? 'opacity-50' : '',
                )
            "
        >
            <span v-if="canRenderVotes">{{ totalVotes }}/{{ expectedVotes }} Votes</span>
            <span v-if="canRenderVotes && canRenderRound">•</span>
            <span v-if="canRenderRound">{{ toOrdinal(round) }} round</span>
        </div>
    </div>
</template>

<style scoped></style>
